import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config'
import article from './modules/article'
import school from './modules/school'
import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    config,
    article,
    school,
    user
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js